import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

function ShortcutKeys({ keys }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      {keys.map((key) => (
        <kbd
          key={key}
          className="inline-flex min-w-[1.25rem] items-center justify-center rounded-md border border-gray-200 bg-white px-1.5 py-0.5 font-sans text-[11px] font-medium leading-none text-gray-500"
        >
          {key}
        </kbd>
      ))}
    </span>
  );
}

const ShortcutsModal = ({ open, onClose, sections = [] }) => (
  <Transition.Root show={open} as={Fragment}>
    <Dialog as="div" className="relative z-50" onClose={onClose}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500/25 transition-opacity" />
      </Transition.Child>

      <div className="fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6">
        <div className="flex min-h-full items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 translate-y-2 scale-95"
            enterTo="opacity-100 translate-y-0 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0 scale-100"
            leaveTo="opacity-0 translate-y-2 scale-95"
          >
            <Dialog.Panel className="relative w-full max-w-md overflow-hidden rounded-xl bg-white text-left shadow-xl">
              <div className="flex items-start justify-between gap-4 px-6 pt-6">
                <div>
                  <Dialog.Title className="text-xl font-semibold tracking-tight text-gray-900">
                    Keyboard shortcuts
                  </Dialog.Title>
                  <p className="mt-1 text-sm text-gray-500">
                    Jump around without leaving the keyboard.
                  </p>
                </div>
                <button
                  type="button"
                  className="rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-50 hover:text-gray-900"
                  onClick={onClose}
                >
                  <span className="sr-only">Close</span>
                  <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>

              <div className="mt-5 max-h-[70vh] space-y-6 overflow-y-auto px-6 pb-6">
                {sections.map((section) => (
                  <section key={section.title}>
                    <h3 className="text-xs font-medium uppercase tracking-wide text-gray-500">
                      {section.title}
                    </h3>
                    <ul className="mt-2 divide-y divide-gray-100">
                      {section.items.map((item) => (
                        <li key={item.name} className="flex items-center justify-between gap-4 py-2.5">
                          <span className="text-sm text-gray-900">{item.name}</span>
                          <ShortcutKeys keys={item.keys} />
                        </li>
                      ))}
                    </ul>
                  </section>
                ))}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

export default ShortcutsModal;
